/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {Box, Button, CardHeader, Divider, Grid, IconButton, List, ListItem} from '@mui/material';
import SendIcon from '@material-ui/icons/Send';
import DeleteIcon from '@material-ui/icons/Delete';

import { getTemplates } from '../../actions'
import { addTemplate, deleteTemplate } from '../../services'
import AddTemplate from './AddTemplate';
import { sendMMS, sendSMS } from '../../services'

export default function Templates() {
    const theme = useTheme()
    const dispatch = useDispatch()

    const templates = useSelector(state => state.templates)
    const number = useSelector(state => state.number)

    const [title, setTitle] = React.useState('')
    const [message, setMessage] = React.useState('')
    const [media, setMedia] = React.useState('')
    const [visible, setVisible] = React.useState(false)

    useEffect(()=> {
        dispatch(getTemplates())
    }, [])

    const handleSubmit = (event) => {
        event.preventDefault()
        setMessage('')
        setMedia('')
        addTemplate(
            title,
            message, 
            media
        );
    };

    // restructure based on dashboard layout
    return (
        <Box
        container
        boxShadow={3}
        spacing={3}
        sx={{width: '39vw', height: '86vh'}}
        >
            <Box>
                <Button 
                color="secondary" 
                onClick={()=> setVisible(!visible)}
                variant="outlined"
                >
                    {visible ? 'Hide' : 'Add Template'}
                </Button>
            </Box>
            { (visible) && (
                <AddTemplate
                    title={title}
                    message={message}
                    media={media}
                    setTitle={setTitle}
                    setMessage={setMessage}
                    setMedia={setMedia}
                    handleSubmit={handleSubmit}
                />
            )}
            <Divider 
            flexItem
            sx={{
                border: '1px solid',
                width: '85%',
                mx: 'auto',
                mt: 2
            }}
            />
            <Grid
            container
            direction="column"
            alignItems="center"
            justify="center"
            sx={{
                background: theme.palette.primary.dark,
            }}
            >
              <List
              sx={{
                  height: '75vh',
                  overflowY: 'auto'
              }}>
                {
                  templates.map((element, index) => {
                      return (
                    <> 
                        <IconButton
                        aria-label="respond"
                        color="secondary"
                        sx={{mx: '20px'}}
                        onClick={() => element.media ? 
                        sendMMS(number.to, element.message, element.media) : 
                        sendSMS(number.to, element.message)}
                        >
                            <SendIcon />
                        </IconButton>
                        <IconButton 
                        aria-label="delete"
                        color="error"
                        onClick={()=> deleteTemplate(element._id)}
                        >
                            <DeleteIcon />
                        </IconButton>
                        <ListItem
                            key={index}>
                            <CardHeader
                                title={`Template: ${element.title}`}
                                subheader={element.message}
                                sx={{
                                    background: 'transparent',
                                }} />
                        </ListItem>
                        {element?.media && (
                            <img
                            src={`${element.media}`}
                            srcSet={`${element.media}`}
                            style={{ width: '100px', marginLeft: '30px'}}
                            alt="Media"
                            loading="lazy" />
                        )}
                        <Divider
                        flexItem
                        sx={{
                            border: `1px solid`,
                            width: '85%',
                            mx: 'auto',
                            mt: 2
                        }}
                        />
                    </>
                  )})	
                }
              </List>
          </Grid>
        </Box>
    )
}